module.exports = __webpack_public_path__ + "static/media/img2.8bb3ca36.jpg";